<template>
  <div class="wrapper">
      <div class="banner">
           <el-carousel arrow="never" height="400px">
                <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                     <div class="pic_item">
                       <img :src="item.url"  style="" class="img">
                       <h3>{{item.title}}</h3>
                    </div>
                </el-carousel-item>
            </el-carousel>
      </div>
      <div class="expert-box">
         <div class="center-wrapper">
             <el-button type="primary">检测专家</el-button>
             <el-button class="apply" @click="handleApply()">申请入驻</el-button>
             <div class="expert-info">
                   <div
                      v-for="(item,index) in infoList"
                      :key="index"
                      class="item-box"
                    >
                      <ExpertInfo :infoItem="item" />
                    </div>
             </div>
         </div>
      </div>
      <!-- 申请入驻 -->
      <el-dialog
        class="applyDailog"
        title="申请入驻"
        :visible.sync="dialogVisible"
        width="60%"
        :lock-scroll="false"
        :show-close="true"
        @close="handleClose"
        z-index="1000"
        >
        <div slot="title" class="title-box">
           <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="16">
                  <span class="title-name">申请入驻</span>
                  <span class="title-dec">快速签约，入驻成为甄宝阁鉴定专家</span>
              </el-col>
           </el-row>
          
        </div>
        <div class="from-detail">
             <el-form :model="form" label-width="100px" :rules="rules" ref="form">
           <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="8">
                <el-form-item label="真实姓名" prop="title">
                  <el-input v-model="form.title"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input v-model="form.mobile" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="8">
                <el-form-item label="联系邮箱" prop="email">
                  <el-input v-model="form.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
               <el-form-item label="联系QQ" prop="qq">
                  <el-input v-model="form.qq"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="16">
                <el-form-item label="擅长类目" prop="provide_service">
                    <el-input v-model="form.provide_service"></el-input>
                </el-form-item>
              </el-col>
             </el-row>
             <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="16">
                <el-form-item label="资质认证" prop="working_certificate">
                  <el-checkbox-group v-model="form.working_certificate">
                    <el-checkbox-button v-for="qual in qualifications" :label="qual" :key="qual">{{qual}}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
             </el-row>
            <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="16">
                <el-form-item label="鉴定资厉" prop="working_years">
                     <div style="width:60px;display:flex;">
                       <el-input v-model.number="form.working_years"></el-input>
                       <span style="margin-left:4px;">年</span>
                     </div>
                </el-form-item>
              </el-col>
            </el-row>
             <el-row type="flex" justify="center" :gutter="100">
              <el-col :span="16">
                <el-form-item label="工作经验" prop="content">
                    <el-input type="textarea" v-model="form.content" maxlength="200" :row="2"></el-input>
                </el-form-item>
              </el-col>
             </el-row>
             <el-form-item style="display:flex;justify-content:center;">
              <el-button @click="onSubmit('form')">提交</el-button>
            </el-form-item>
        </el-form>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import ExpertInfo from "../components/ExpertInfo.vue";
import {experts, fetchExpertInfo, postExpertsIn} from '../api/api.js';
export default {
  name:'Expert',
  components: {
     ExpertInfo,
  },
  props: {},
  data() {
    return {
      bannerList: [
        {
           url:require('../assets/img/banner.png'),
           title:'《义薄云天》李树雷作品 >>'
        },
         {
           url:require('../assets/img/banner.png'),
           title:'《义薄云天》李树雷作品 >>'
        },
         {
           url:require('../assets/img/banner.png'),
           title:'《义薄云天》李树雷作品 >>'
        },
      ],
      infoList : [],
      dialogVisible:false,
      qualifications:['FGA','GIA','CGC','GIC','IGI','NGTC','其他'],
      form:{
        title:'',
        mobile:'',
        email:'',
        qq:'',
        provide_service:'',
        working_certificate:[],
        working_years:'',
        content:''
      },
       rules:{
         title: [
            { required: true, message: '请输入真实姓名' },
          ],
          mobile: [
            { type: 'string',required: true, message: '请输入手机号码'},
          ],
          email :[
             { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
          ],
          provide_service: [
            { required: true, message: '请输入擅长类目'}
          ],
          working_certificate: [
            { required: true, message: '请选择资质认证'}
          ],
          working_years: [
            { required: true, message: '请输入鉴定资历'},
             { type: 'number', message: '鉴定资历必须为数字'}
          ],
          content: [
            { required: true, message: '请输入工作经验'}
          ],
      },
      tipDialogVisible:false
    };
  },
  watch: {
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
      experts({
        page: 1,
        per_page: 40,
      }).then(res => {
        this.infoList = res.data.data;
      }).catch((err) => {
         console.log('err',err)
      })
  },
  methods:{
    handleApply(){
       this.handleOpen();
    },
    wheelHandler(e){
      e.preventDefault();
    },
    handleOpen(type) {
      this.dialogVisible = true ;
      window.addEventListener('wheel',this.wheelHandler,{
         passive:false,
      })
    },
    handleClose(type) {
        this.dialogVisible = false;
        this.$refs['form'].resetFields();
        window.removeEventListener('wheel',this.wheelHandler,{
         passive:false,
       })
    },
    onSubmit(formName) {
       this.$refs[formName].validate((valid) => {
          if (valid) {
             let params = Object.assign({},this.form);
             params.working_years = params.working_years + '';
             params.working_certificate = params.working_certificate.join(',');
            postExpertsIn(params).then(res => {
               if(res.data.code === 0) {
                  this.$message({
                      message: '提交成功！',
                      type: 'success',
                  });
                this.$refs[formName].resetFields();
                this.handleClose();
               } else {
                  this.$message({
                      message: `${res.data.msg}`,
                      type: 'success'
                  });
                  return false;
               }
             
            })
          } else {
            return false;
          }
       })
    },
  }
};
</script>
<style lang="scss" scoped>
.wrapper{ 
    .banner {
      width: 100%;
      height: 400px;
      position: relative;
      overflow: hidden;
      .pic_item {
        height:100%;
        width:100%;
      }
      .el-carousel__item h3 {
        color: white;
        font-size: 30px;
        font-weight: 700;
      }
      /* TODO: */
      .img {
        height:100%;
        width:100%;
        object-fit:cover;
      }
      h3 {
        position: absolute;
        left: 22rem;
        bottom: 2rem;
      }
    }
  .banner ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
    width: 10px;
    height: 10px;
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 50%;
    opacity: 0.5;
  }  
 .banner ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button{
    width: 10px;
    height: 10px;
    background: #ffffff;
    border-radius: 50%;
    opacity: 1;
  }
  .banner ::v-deep .el-carousel__indicators { 
      left: unset;
      transform: unset;
      right: 20%;
  }

  .expert-box {
     width: 100%;
     height: auto;
     padding-top:50px;
     padding-bottom: 100px;
     background: rgb(240, 240, 240);
    .el-button {
      background: #2093ca;
    }
     .apply {
        background: transparent;
        border:1px solid rgba(32, 147, 202, 1);
        color: rgba(32, 147, 202, 1);
     }
     .expert-info {
       width: 100%;
       height: auto;
       padding-top: 40px;
       display: flex;
      //  justify-content: center;
       align-items: center;
       flex-wrap: wrap;
        .item-box {
           width: 25%;
           min-width: 300px;
           height: 410px;
        }
     }
  }
  .applyDailog {
      .title-name {
        font-size: 24px;
        font-weight: 700;
        line-height: 0px;
        color: rgba(32, 147, 202, 1);
      }
      .title-dec {
        font-size: 14px;
        font-weight: 400;
        color: rgba(114, 113, 113, 1);
        padding-left: 16px;
      }
      ::v-deep .el-dialog__header {
        border-bottom: 1px solid #ebebeb;
      }
      ::v-deep .el-dialog__header {
        padding-top: 40px;
        padding-bottom: 26px;
      }
      ::v-deep .el-dialog__headerbtn {
          display: block;
          width: 30px;
          height: 30px;
          background: rgba(255, 255, 255, 0.25);
          border-radius: 50%;
          position: absolute;
          top: -23px;
          right: -30px;
      }
      ::v-deep .el-dialog__headerbtn .el-dialog__close {
         color: #ffffff;
         font-size: 18px;
      }
  }
   ::v-deep .el-dialog{
      border-radius: 14px;
    }
  .from-detail {
    ::v-deep .el-checkbox-button__inner:first-child {
      border-left:none;
    }
    ::v-deep .el-checkbox-button__inner {
        height: 21px;
        display: flex;
        align-items: center;
        margin: 0 10px;
        color: rgba(204, 204, 204, 1);
        border-color:rgba(204, 204, 204, 1);
        border-left: 1px solid rgba(204, 204, 204, 1);
        border-radius: 100px;
    }
    ::v-deep .is-checked .el-checkbox-button__inner {
        color: #ffffff;
        border-color: #2093ca;
        background:#2093ca;
    }
    ::v-deep .el-input__inner {
        padding: 0 8px;
        height: 30px;
    }
    .el-button {
      width: 240px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #2093ca;
      color: #ffffff;
      font-size: 20px;
      letter-spacing: 4px;
    }
  }
  
  .consult-box {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(124,124,124,0.6);
    .mask {
        position: absolute;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        // animation: dialog-fade-in 0.2s linear 1;
        
    }
     .content {
      width: 570px;
      height: 199px;
      border-radius: 14px;
      background: url("../assets/img/tipsBg.png") no-repeat;
      position: relative;
      animation: dialog-fade-in .5s;
      .close {
        position: absolute;
        z-index: 999;
        top: -15px;
        left: 100%;
        cursor: pointer;
      }
      .tips {
        position: absolute;
        top: 0;
        left: calc(50% - 30px);
        // transform: translateX(-50%);
        transform: translateY(-50%);
      }
      div {
        position: static;
        height: 199px;
        padding: 30px 50px 0 50px;
        display: inline-flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        span {
         transform: translateY(50%);
         font-size: 16px;
         line-height: 20px;
         font-weight: 400;
         text-align: justify;
       }
      }
      .el-button {
        width: 240px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #2093ca;
        color: #ffffff;
        font-size: 20px;
        letter-spacing: 4px;
      }
     }
  }
}
</style>